import { useContext } from 'react';
import { ScaleContext } from '../providers/ScaleContext';

export function useScale() {
  const context = useContext(ScaleContext);
  if (context === undefined) {
    throw new Error('useScale must be used within a ScaleProvider');
  }
  return context;
}
